import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { MapPage } from '~/features/map/map-page';

/**
 * The Business map (docs/plans/business-map.md Decided 5): the setup sketch,
 * kept as the workspace's map. First in the sidebar's Workspace group, on
 * Workspace details beside Setup, and in ⌘K. `?link=` opens one link's detail
 * sheet over the map (U3 of docs/plans/ui-quick-fixes.md), from a link
 * drawer's Open link.
 */
const search = z.object({ link: z.string().optional() });

function MapRoute(): ReactElement {
  const { link } = Route.useSearch();
  const navigate = Route.useNavigate();
  return <MapPage linkId={link ?? null} onLinkId={(next) => void navigate({ search: next === null ? {} : { link: next } })} />;
}

export const Route = createFileRoute('/_app/business/map')({
  validateSearch: search,
  component: MapRoute,
});
